import type { RootState } from 'react-redux';

import { createSelector } from '@reduxjs/toolkit';

import type { UserProfileState } from './types';

export const userProfile = (state: RootState) => state.userProfile;

export const getNicknameDraft = createSelector(
  userProfile,
  (state: UserProfileState) => state.nicknameDraft,
);

export const getUserProfile = createSelector(userProfile, (state: UserProfileState) => state.data);

export const getUserId = (state: RootState) => {
  return state.userProfile.data.userId;
};

export const isUserProfileLoading = createSelector(
  userProfile,
  (state: UserProfileState) => state.loading,
);

export const isSnsDataUpdating = createSelector(
  userProfile,
  (state: UserProfileState) => state.isSnsDataUpdating,
);
